import { IApiOptions } from './IApiOptions'

export abstract class ApiCore {
    protected readonly serviceBase: string
    protected readonly appJsonHeader: HeadersInit = { 'Content-Type': 'application/json' }

    protected EmptyResponse = {
        json: (): null => null
    }

    protected constructor(options: IApiOptions) {
        this.serviceBase = [options.baseApiUrl, options.apiVersion, options.basePath]
            .filter(item => Boolean(item))
            .join('/')
    }

    public async get(path: string, query: any = {}): Promise<any> {
        return await this.makeRequest('GET', path, query)
    }

    public async delete(path: string, query: any = {}): Promise<any> {
        return await this.makeRequest('DELETE', path, query)
    }

    public async post(path: string, data: any = {}): Promise<any> {
        return await this.makeRequest('POST', path, undefined, data)
    }

    public async put(path: string, data: any = {}): Promise<any> {
        return await this.makeRequest('PUT', path, undefined, data)
    }

    abstract makeRequest(method: string, path: string, query: any, data?: any): Promise<Response>
}
